import $api from "@http";

export default class VideosService {
  static async getVideos({page, size}) {
    return $api.get(`/api/v1/videos?page=${page}&page_size=${size}`);
  }

  static async getAllVideos() {
    return $api.get(`/api/v1/videos`);
  }

  static async viewVideo({id}) {
    return $api.get(`/api/v1/video/${id}`);
  }

  static async createVideo({video}) {
    const hasFiles =
      video.video.file &&
      (video.video.file instanceof File ||
        (video.video.file.file && video.video.file.file instanceof File) ||
        (video.video.file.path && video.video.file.path !== ""));

    if (hasFiles) {
      const formData = new FormData();

      Object.keys(video.video).forEach((key) => {
        if (video.video[key] !== null && video.video[key] !== undefined) {
          if (key === "file" && video.video.file) {
            if (video.video.file instanceof File) {
              formData.append("video[file]", video.video.file);
            } else if (
              video.video.file.file &&
              video.video.file.file instanceof File
            ) {
              formData.append("video[file]", video.video.file.file);
            } else if (video.video.file.path) {
              formData.append("video[file]", JSON.stringify(video.video.file));
            }
          } else {
            formData.append(`video[${key}]`, video.video[key]);
          }
        }
      });

      return $api.post(`/api/v1/videos`, formData);
    } else {
      return $api.post(`/api/v1/videos`, video);
    }
  }

  static async updateVideo({id, video}) {
    const hasFiles =
      video.video.file &&
      (video.video.file instanceof File ||
        (video.video.file.file && video.video.file.file instanceof File) ||
        (video.video.file.path && video.video.file.path !== ""));

    if (hasFiles) {
      const formData = new FormData();

      Object.keys(video.video).forEach((key) => {
        if (video.video[key] !== null && video.video[key] !== undefined) {
          if (key === "file" && video.video.file) {
            if (video.video.file instanceof File) {
              formData.append("video[file]", video.video.file);
            } else if (
              video.video.file.file &&
              video.video.file.file instanceof File
            ) {
              formData.append("video[file]", video.video.file.file);
            } else if (video.video.file.path) {
              formData.append("video[file]", JSON.stringify(video.video.file));
            }
          } else {
            formData.append(`video[${key}]`, video.video[key]);
          }
        }
      });

      return $api.patch(`/api/v1/videos/${id}`, formData);
    } else {
      return $api.patch(`/api/v1/videos/${id}`, video);
    }
  }
}
